module.exports = __webpack_public_path__ + "img/step4-mobile-fr@2x.48aaacd7.webp";